import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Emblem() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Our Emblem & Motto"
          title2=""
          parentTitle="About"
          path="Our Emblem & Motto"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="row about-grid align-items-stretch">
            {/* Left Content */}
            <div className="col-12 col-xl-8">
              <div className="contact-form-card">
                <h2 className="about-title"> Our Emblem & Motto</h2>

                <div className="about-content-card">
                  <p>
                    The two palms at the base indicate the Mighty Hands of God
                    the almighty who is the author and source of all wisdom and
                    knowledge. By keeping everything in the hands of God, we
                    express our faith and trust in the powerful support of God,
                    in all our endeavours. The letter ‘M’ stands for Mother
                    Mary, the Patroness of Carmel School. The school and the
                    school community staff and students are dedicated to her
                    patronage and protection. This letter also indicates the
                    middle letter in the name of C.M.C congregation who runs
                    Carmel School. There is a big ‘C’ on the right side of which
                    there is a small ‘c’. Thus the big ‘C’ the ‘M’ and the small
                    ‘c’ together constitute the name C.M.C. The big ‘C’ also
                    stands for Carmel School. The lotus flower in the centre
                    stands for knowledge. The lamp represents the school, the
                    abode knowledge, the temple of learning. The flame is the
                    symbol of the knowledge and inspiration imparted by Carmel
                    School. The two children, a girl and a boy, representing the
                    student’s community lit their lamp from the flame which is a
                    symbolic expression of receiving education from their Alma
                    Mater. On the two sides we find two wings rising high
                    holding the motto “Let Your Light Shine” up. The wings
                    rising up convey the noble idea that the children formed in
                    Carmel School will soar high in fear of God, knowledge and
                    brilliance.The motto of the school, “LET YOUR LIGHT SHINE”
                    posses the goal which the staff and the students should ever
                    keep before them. The motto stands for what is best in
                    education. It aims at the development of the noblest
                    faculties of a child. It aims at forming each into a perfect
                    personality to shine distinctly in a world of darkness.
                    Knowledge enlightens, dispels the darkness of ignorance
                    error and misconception. Proper formation makes a person
                    disciplined, poised, capable, determined, and thus
                    thoroughly equipped for the battle of life. The school aims
                    at forming good citizen who will hold on to noble values and
                    whose light will radiate goodness, love, justice and peace
                    in places where they live and move. They will work as leaven
                    in the society for the betterment of the people and of the
                    society as a whole.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-12 col-xl-4">
              <div className="contact-map-card about-image-card">
                <div className="about-image-wrap">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Emblem.jpg"
                    alt="About School"
                    className="about-main-image img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Emblem;
